import React, {Component} from 'react';
import Actionbar from "../Common/Actionbar";
import Navbar from "../Common/Navbar";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {

    faCoins, faEye, faList,  faPlus, faWallet

} from '@fortawesome/free-solid-svg-icons'

import API from "../../services/API";

const currencyFormat = Intl.NumberFormat('en-US');
class Finance extends Component {
    state ={
        showRequests: 0,
        finance:{
            transactions : [],
            requests : [],

        },
        user : []
    }

    render() {
        return (
            <React.Fragment>
                <Actionbar noBack={0} title=' گزارش مالی'  />
                <main className="container-fluid  pt-3 rtl">
                    <div className="row px-2">
                        <div className="col-12 border text-center py-2 bg-opacity-10 bg-secondary small rounded">
                            گزارش مالی
                            &nbsp;
                            {this.state.user.first_name}
                            &nbsp;
                            {this.state.user.last_name}
                        </div>
                        <div className="col-1 mt-5">
                            <FontAwesomeIcon icon={faCoins} className='text-secondary' />
                        </div>
                        <div className="col-6 mt-5">
                            مبلغ علی الحساب:
                        </div>
                        <div className="col-5 mt-5 text-left">
                            {

                                currencyFormat.format(this.state.finance.temp)
                            }
                            &nbsp;
                            ریال
                        </div>

                        <div className='text-right col-12 text-primary super-small mt-3'
                        onClick={() => this.setState({
                            'showRequests' : 1 - this.state.showRequests
                        })}
                        >
                            این مبلغ بابت تعداد
                            <b className='mx-2'>{this.state.finance.count}</b>
                            درخواست است
                            <FontAwesomeIcon icon={faEye} className='mx-2' />
                        </div>
                        {
                            this.state.showRequests > 0 &&

                            <div className="col-12 mt-3">
                                {
                                    this.state.finance && this.state.finance.requests.map(req=> {
                                        return (
                                            <div className="row menu-list-item bg-info bg-opacity-10 py-2 super-small">
                                                <div className="col-12">
                                                     درخواست شماره
                                                    &nbsp;
                                                    {req.tracking_code}
                                                    &nbsp;
                                                    تاريخ
                                                    &nbsp;
                                                    {req.created_at}

                                                </div>
                                                       {/* <div className="col-4 text-left fw-bold">
                                                    {
                                                        currencyFormat.format(req.driver_share)
                                                    }
                                                    &nbsp;
                                                    ریال
                                                </div>*/}
                                            </div>
                                        )
                                    })
                                }

                            </div>
                        }

                        <div className="col-12 my-3 text-justify border-bottom pb-3 super-small-2 text-secondary">
                            <span>
                                این مبلغ به صورت علی الحساب است. لطفا جهت محاسبه مبلغ نهایی مدارک تخلیه بار به شرکت تحویل دهید.

                            </span>
                        </div>
                        <div className="col-1 mt-5">
                            <FontAwesomeIcon icon={faWallet} className='text-secondary' />
                        </div>
                        <div className="col-6 mt-5">
                          مبلغ بستانکاری قطعی :
                        </div>
                        <div className="col-5 mt-5 text-left">
                            {

                                currencyFormat.format(this.state.finance.wallet_inventory)
                            }
                            &nbsp;
                            ریال
                        </div>
                        <div className="col-12 my-3 text-justify border-bottom pb-3 super-small-2 text-secondary">
                            <span>
                      این مبلغ میزان کل بستانکاری شما از شرکت می باشد که با شما تسویه خواهد شد
                            </span>
                        </div>
                    </div>
                    <div className="row my-4 pb-4">
                        <div className="col-1 border-bottom pb-2">
                            <FontAwesomeIcon icon={faList} />
                        </div>
                        <div className="col-11 border-bottom pb-2 fw-bold">
                            آخرین واریزی ها از طرف شرکت
                        </div>
                  {/*      <div className="col-6 super-small-2 py-2 text-primary text-left"
                        onClick={() => {
                            this.props.history.push('/wallet')
                        }}
                        >
                            مشاهده کیف پول
                            &nbsp;
                            <FontAwesomeIcon icon={faAngleLeft} />
                        </div>*/}
                        <div className="col-12 pb-5 mb-5 ">
                            {
                                this.state.finance.transactions.map(tr=> {
                                    if(tr.increase_amount > 0) {
                                        return (
                                            <div className="row mt-2 rtl p-3 menu-list-item bg-secondary bg-opacity-10"
                                                 key={tr.id}>
                                                <div className="col-1">
                                                    <FontAwesomeIcon icon={faPlus} className="text-success"/>
                                                </div>
                                                <div className="col-7 text-dark menu-text ">
                                                    {currencyFormat.format(tr.increase_amount)}
                                                    &nbsp;
                                                    ریال
                                                    <div className="super-small fw-light pt-2 text-secondary">
                                                        <b>{tr.title}</b>
                                                        &nbsp;
                                                        {tr.description}
                                                    </div>
                                                </div>
                                                <div className="col-4 super-small-2 text-secondary text-left">
                                                    {tr.created_at}
                                                </div>

                                            </div>
                                        )
                                    }
                                    else {
                                        return (
                                            <div className="row mt-2 rtl p-3 menu-list-item bg-secondary bg-opacity-10"
                                                 key={tr.id}>
                                                <div className="col-1">
                                                    <FontAwesomeIcon icon={faPlus} className="text-success"/>
                                                </div>
                                                <div className="col-7 text-dark menu-text ">
                                                    {currencyFormat.format(tr.decrease_amount)}
                                                    &nbsp;
                                                    ریال
                                                    <div className="super-small fw-light pt-2 text-secondary">
                                                        <b>{tr.title}</b>
                                                        &nbsp;
                                                        {tr.description}
                                                    </div>
                                                </div>
                                                <div className="col-4 super-small-2 text-secondary text-left">
                                                    {tr.created_at}
                                                </div>

                                            </div>
                                        )
                                    }


                                })
                            }
                        </div>
                    </div>

                </main>
                <Navbar  />
            </React.Fragment>
        );
    }
    componentDidMount = () => {
        API.index()
            .then((response) => {
                this.setState({user : response.results.user})
            })
        API.finance()
            .then((response) => {
                this.setState({finance : response.results})
            })
    }
}

export default Finance;
